import PropTypes from 'prop-types';
import ParagraphFAQ from "components/ui/Paragraphs/ParagraphFAQ";
import ParagraphText from "components/ui/Paragraphs/ParagraphText";
import ParagraphMedia from "components/ui/Paragraphs/ParagraphMedia";
import "components/ui/Paragraphs/Paragraph.scss";

const Paragraph = ({ type, content }) => {
  let paragraph;
  switch (type) {
    case 'faq':
      paragraph = <ParagraphFAQ questions={ content.field_faq_questions }/>
      break;

    case 'text':
      paragraph = <ParagraphText title={ content.field_title ? content.field_title.value : '' }
                                 text={ content.field_text.value }/>
      break;
    case 'media':
      paragraph = <ParagraphMedia title={ content.field_title ? content.field_title.value : '' }
                                  media={ content.field_media.field_media_image.value }/>
      break;
    default:
      paragraph =
        <strong>** Unknown paragraph type "{ type }", add it to Paragraph.js
          **</strong>
  }

  return (
    <div className={ `paragraph paragraph--${ type }` }>
      { paragraph }
    </div>
  )
}

Paragraph.propTypes = {
  type: PropTypes.string,
  content: PropTypes.object,
}

export default Paragraph;
